define([], function () {

	'use strict';

	return {
		ROOT: '/myaccount/',
		breakpoints: {
			phone: {
				portrait: {
					min: 320,
					max: 479
				},
				landscape: {
					min: 480,
					max: 640
				}
			},
			tablet: {
				portrait: {
					min: 641,
					max: 768
				},
				landscape: {
					min: 769,
					max: 1024
				}
			}
		},
		wallet: {
			bank: {
				MAX_BANKS_LIMIT: 8,
				errors: {
					invalidPayPalCodeBlocked: '4054',
					yodleeErrorMaxLoginAttemptsExceeded: '42',
					attemptsExceeded: '90008',
					invalidMFA: '90010'
				},
				BRAZIL_CITIBANK: '745',
				HSBC: '399',
				SANTANDER: '033',
				CHECKING: 'checking',
				BANCO_DA_BRASIL: '001',
				ITAU_UNIBANCO: '341'

			},
			card: {
				MAX_CARDS_LIMIT: 8,
				errors: {
					invalidRDCardBlocked: '4006',
					invalidPayPalCodeCardBlocked: '4012'
				}
			}
		},

		pagenames: {

		}
	};
});



//////////////////
// WEBPACK FOOTER
// ./constants.js
// module id = 7
// module chunks = 0